export default "__VITE_ASSET__003b89bd__"